export const API_BASE_URL =
  process.env.VUE_APP_API_BASE_URL || "https://api-test.oxvalue.ai/api";
